import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CompanySettingsState } from '../state/company-settings.state'

export const getCompanySettings = createFeatureSelector<CompanySettingsState>('companySettings')

export const getEnabledModules = createSelector(getCompanySettings, state => state.enabledModules)

export const getSettingsLoaded = createSelector(getCompanySettings, state => state.loaded)
